webpackJsonp([1],{

/***/ "0sbj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.cc37ca0.png";

/***/ }),

/***/ "8qAi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DgNL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F53E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I6Jg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Trust-waratah-colour-small.7fd66c9.png";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./src/fonts.css
var fonts = __webpack_require__("DgNL");
var fonts_default = /*#__PURE__*/__webpack_require__.n(fonts);

// EXTERNAL MODULE: ./node_modules/material-design-icons/iconfont/material-icons.css
var material_icons = __webpack_require__("uTBe");
var material_icons_default = /*#__PURE__*/__webpack_require__.n(material_icons);

// EXTERNAL MODULE: ./src/stylus/main.styl
var main = __webpack_require__("tLfa");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./node_modules/please-wait/build/please-wait.css
var please_wait = __webpack_require__("c+ko");
var please_wait_default = /*#__PURE__*/__webpack_require__.n(please_wait);

// EXTERNAL MODULE: ./node_modules/spinkit/css/spinners/6-chasing-dots.css
var __chasing_dots = __webpack_require__("0sbj");
var __chasing_dots_default = /*#__PURE__*/__webpack_require__.n(__chasing_dots);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/is-finite.js
var is_finite = __webpack_require__("AMV0");
var is_finite_default = /*#__PURE__*/__webpack_require__.n(is_finite);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./src/RandR.js

var helpPage = '<!DOCTYPE html>' + '<html lang="en">' + '<head>' + '<title>restore-and-renew Help</title>' + '<meta charset="utf-8">' + '<meta name="viewport" content="width=device-width, initial-scale=1">' + '<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.1.0/css/bootstrap.min.css">' + '<!--<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>' + '<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.0/umd/popper.min.js"></script>' + '<script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.1.0/js/bootstrap.min.js"></script>-->' + '<link rel="icon" type="image/x-icon" href="/static/favicon.ico">' + '<style>' + '@media print {' + '@page {' + 'size: A4;' + 'margin: 5mm;' + '}' + 'html, body {' + 'width: 1024px;' + '}' + 'body {' + '/*margin: 0 auto;*/' + 'font-size: 14px;' + '}' + '.container-fluid {' + 'width: auto;' + 'min-width: 750px;' + '}' + '.col-sm-12, .col-sm-6 {' + 'float:left;' + '}' + '.col-sm-12 {' + 'width: 40%;' + '}' + '.col-sm-6 {' + 'width: 20%;' + '}' + '}' + '</style>' + '</head>' + '<body>' + '<div class="container-fluid">' + '<div class="row py-4">' + '<div class="col-sm-8"><h1 style="color: #1C6293;">Welcome to the Restore & Renew webtool</h1></div>' + '<div class="col-sm-4"><img src="data/images/help/logo_small.png" alt="Restore and Renew logo" class="float-right"></div>' + '</div>' + '<div class="row py-2">' + '<div class="col-sm-12">' + '<h2 style="color: #1C6293;">What does the Restore & Renew webtool do?</h2>' + '<p>The webtool uses genetic, climatic and distributional information for selected plant species used in restoration. It is an ongoing project and new species will be added as the information becomes available.</p>' + '<p>For completed species at your selected site the tool provides:</p>' + '<ul>' + '<li>Site specific (selected by you) information on local genetic provenance of the selected species</li>' + '<li>Information on the current distribution of the selected species</li>' + '<li>A map indicating where current climatic conditions similar to those within your selected site are found</li>' + '<li>A map indicating where the conditions at your site in the future (2050) can be found <b>now</b>. This map represents conditions which will <i>come to your selected location by 2050</i>)</li>' + '<li>A printable summary document providing a brief description of the species selected, its distribution, predicted change in habitat availability, the geographic boundaries of local provenance based on your selected site, the distribution of climatic conditions that are similar to those at your site. Suggestions on how to apply this information within a range of restoration scenarios are also provide</li>' + '</ul>' + '<p>More information about the Restore &amp; Renew project is available <a href="https://www.rbgsyd.nsw.gov.au/science/restore-renew">here</a>, or email us at <a href="mailto:Restore.Renew@rbgsyd.nsw.gov.au">Restore.Renew@rbgsyd.nsw.gov.au</a>.</p>' + '<p><b>Please note:</b> The Restore &amp; Renew project uses species names from the National Species List (NSL) maintained by the Atlas of Living Australia. The plant names on the NSL are derived from the Australian Plant Census maintained by the Council of Heads of Australasian Herbaria (CHAH).</p>' + '</div>' + '</div>' + '<div class="row py-2">' + '<div class="col-sm-6">' + '<h2 style="color: #1C6293;">Using the Restore & Renew webtool</h2>' + '<p>The webtool has two components:</p>' + '<ol>' + '<li>an options and information panel, and,</li>' + '<li>an interactive map.</li>' + '</ol>' + '<p>Results are generated in three steps by choosing options in the left panel (area 1). Completing each step in the sequence will automatically move you to the next step. <strong>You can go back and change any of the options you select in previous steps at any time by clicking on the step.</strong> The results of the options you choose will be displayed live on the map to the right (area 2).</p>' + '</div>' + '<div class="col-sm-6">' + '<img src="data/images/help/Webtool_help_firstScreen_1_2_v2.png" alt="RandR webtool has 2 components" class="float-left img-fluid border border-dark" style="box-shadow: 5px 5px 5px grey;">' + '</div>' + '</div>' + '<div class="row">' + '<div class="col-sm-12">' + '<h2 style="color: #1C6293;">The steps</h2>' + '</div>' + '</div>' + '<!-- Step 1 -->' + '<div class="row py-2">' + '<div class="col-sm-6">' + '<h4 style="color:#3871ac;">Step 1: Select a location</h4>' + '<p>Selecting a location places a blue marker on the map display (near red arrow in the next image). You can enter a location in three different ways:</p>' + '<ol>' + '<li>Move the map display and zoom in to see the region around your site, then click on the map at your site. Latitude and longitude will be read from the map.</li>' + '<li>Type in the decimal latitude and longitude in the text fields in the option panel.</li>' + '<li>Click in the "Find a place" box at the top-left of the map and enter a location name, or street address.</li>' + '</ol>' + '</div>' + '<div class="col-sm-6">' + '<img src="data/images/help/Webtool_Howto_locationMarker_circle.png" alt="Location selected showing blue marker" class="float-left img-fluid border border-dark" style="box-shadow: 5px 5px 5px grey;">' + '</div>' + '</div>' + '<!-- Step 2 -->' + '<div class="row py-2">' + '<div class="col-sm-6">' + '<h4 style="color:#3871ac;">Step 2: Select a species</h4>' + '<p>Select from the species for which <b>data is available at your site</b> by:</p>' + '<ol>' + '<li>Using the pull-down list with your mouse (or arrow and enter keys)</li>' + '<li>Begin typing the species name until a match is found and then select your species.</li>' + '</ol>' + '<p>The list you see is trimmed automatically to show only those species for which data is available at your selected site. New species are being added to the Restore & Renew webtool as information becomes available (a list of the target species is available <a href="https://www.rbgsyd.nsw.gov.au/science/restore-renew/target-species-directory">here</a>) and the list available at your selected site will grow over time.</p>' + '</div>' + '<div class="col-sm-6">' + '<img src="data/images/help/Restore_and_Renew_HowTo_species_small.png" alt="Species selection list" class="float-left img-fluid border border-dark" style="box-shadow: 5px 5px 5px grey;">' + '</div>' + '</div>' + '<!-- Step 3 -->' + '<div class="row py-2">' + '<div class="col-sm-6">' + '<h4 style="color:#3871ac;">Step 3: Review results</h4>' + '<p>Once you have completed step 2, the webtool will begin computing important spatial data which will be displayed on the map. Four items of data will be produced <i>for your selected location and species</i>:</p>' + '<ol>' + '<li><strong>Herbarium records</strong> will be indicated by red dots as a guide to the known distribution of the selected species</li>' + '<li><strong>Recommended collection area</strong> displays the local genetic provenance around your selected site. This is indicated by the highlighted area centred at your site and surrounded by a greyed area (the area outside the local genetic provenance)</li>' + '<li><strong>Similar environments (current)</strong> indicates areas which closely match the climate currently experienced at your selected location (purple highlights)</li>' + '<li><strong>Similar future environments (2050)</strong> displays areas with climatic conditions that are present in the landscape <i>now</i> and are similar to those expected to be at your selected site in 2050 (optional orange highlights – these are not displayed by default – first on right)</li>' + '</ol>' + '<p>The map legend in the <em>Results</em> section of the <em>Options</em> panel allows you to turn any of the displayed map layers on or off by clicking the check-boxes. For example, the second image shows the map display with the optional future environment match layer turned on.</p>' + '</div>' + '<div class="col-sm-6">' + '<div class="row py-2">' + '<img src="data/images/help/Webtool_howto_maplegend_default.png" alt="Review results" class="float-left img-fluid border border-dark" style="box-shadow: 5px 5px 5px grey;">' + '</div>' + '<div class="row py-2">' + '<img src="data/images/help/Webtool_howto_maplegend_allSelected.png" alt="Check-boxes control layers displayed" class="float-left img-fluid border border-dark" style="box-shadow: 5px 5px 5px grey;">' + '</div>' + '</div>' + '</div>' + '<!-- Other options -->' + '<div class="row py-2">' + '<div class="col-sm-12">' + '<h2 style="color: #1C6293;">Other options:</h2>' + '</div>' + '</div>' + '<div class="row py-2">' + '<div class="col-sm-6">' + '<h4 style="color:#3871ac;">Display detailed results</h4>' + '<p>The "Display results" button becomes active when you have successfully selected a location and species. Click on this button to see a detailed report including guidance on applying these results to one of several restoration scenarios. The report is displayed in a new tab so you will still be able to go back to the options and map display tab. You will also be able to click an option in the new tab to print the report or create a PDF.</p>' + '<h4 style="color:#3871ac;">Species background information</h4>' + '<p>After you have selected a species, an information icon will be displayed next to the species name. Clicking this will open a window with background information about the species. Links below the species name will open <strong>PlantNET</strong> and <strong>Atlas of Living Australia</strong> pages for the species. Each will be opened in a new tab.</p>' + '<h4 style="color:#3871ac;">Reset button</h4>' + '<p>Clicking on the “Reset” button at the bottom of the <i>Options</i> panel will clear all previous option selections and take you back to Step 1. Remember that if you want to keep the information you just obtained, press the “Display results” button to print or save a PDF before pressing the “Reset” button.</p>' + '</div>' + '<div class="col-sm-6">' + '<img src="data/images/help/Webtool_Howto_hover_over_display_results_cropped2_small.png" alt="Display results button active" class="float-left img-fluid border border-dark" style="box-shadow: 5px 5px 5px grey;">' + '</div>' + '</div>' + '</div>' + '<div class="row">' + '<div class="col-sm-12">' + '<hr>' + '<p style="text-align:center;">Copyright &copy; 2018 NSW Government</p>' + '</div>' + '</div>' + '</body>' + '</html>';
// EXTERNAL MODULE: ./node_modules/please-wait/build/please-wait.js
var build_please_wait = __webpack_require__("a3f3");
var build_please_wait_default = /*#__PURE__*/__webpack_require__.n(build_please_wait);

// EXTERNAL MODULE: ./node_modules/mapbox-gl/dist/mapbox-gl.js
var mapbox_gl = __webpack_require__("1e2d");
var mapbox_gl_default = /*#__PURE__*/__webpack_require__.n(mapbox_gl);

// EXTERNAL MODULE: ./node_modules/mapbox-gl/dist/mapbox-gl.css
var dist_mapbox_gl = __webpack_require__("xnE8");
var dist_mapbox_gl_default = /*#__PURE__*/__webpack_require__.n(dist_mapbox_gl);

// EXTERNAL MODULE: ./node_modules/@mapbox/mapbox-gl-geocoder/lib/index.js
var mapbox_gl_geocoder_lib = __webpack_require__("xQT3");
var mapbox_gl_geocoder_lib_default = /*#__PURE__*/__webpack_require__.n(mapbox_gl_geocoder_lib);

// EXTERNAL MODULE: ./node_modules/@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css
var mapbox_gl_geocoder = __webpack_require__("8qAi");
var mapbox_gl_geocoder_default = /*#__PURE__*/__webpack_require__.n(mapbox_gl_geocoder);

// EXTERNAL MODULE: ./node_modules/d3-request/index.js + 22 modules
var d3_request = __webpack_require__("IT06");

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__("OAwv");
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// EXTERNAL MODULE: ./node_modules/which-polygon/index.js
var which_polygon = __webpack_require__("3TbV");
var which_polygon_default = /*#__PURE__*/__webpack_require__.n(which_polygon);

// EXTERNAL MODULE: ./node_modules/@turf/bbox/index.js
var bbox = __webpack_require__("5GQ8");
var bbox_default = /*#__PURE__*/__webpack_require__.n(bbox);

// EXTERNAL MODULE: ./node_modules/clipboard/lib/clipboard.js
var clipboard = __webpack_require__("V33R");
var clipboard_default = /*#__PURE__*/__webpack_require__.n(clipboard);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/topojson-client/index.js + 12 modules
var topojson_client = __webpack_require__("bPnB");

// EXTERNAL MODULE: ./node_modules/@turf/mask/main.es.js + 2 modules
var main_es = __webpack_require__("dy4M");

// EXTERNAL MODULE: ./node_modules/@turf/difference/main.es.js + 2 modules
var difference_main_es = __webpack_require__("E+DG");

// EXTERNAL MODULE: ./node_modules/@turf/combine/index.js
var combine = __webpack_require__("bEHx");
var combine_default = /*#__PURE__*/__webpack_require__.n(combine);

// EXTERNAL MODULE: ./node_modules/mobile-detect/mobile-detect.js
var mobile_detect = __webpack_require__("UMwo");
var mobile_detect_default = /*#__PURE__*/__webpack_require__.n(mobile_detect);

// CONCATENATED MODULE: ./src/Theme.js
/* harmony default export */ var Theme = ({
  primary: '#a1ae39',
  secondary: '#383a3e',
  promo1: '#5a4185',
  promo2: '#3e5da3',
  promo3: '#69bade',
  promo4: '#3f797e',
  promo5: '#009f70',
  promo6: '#80c342',
  promo7: '#e3305e',
  promo8: '#f47932',
  promo9: '#e9ae21',
  promo10: '#ffcf31',
  gray: '#aaa',

  herbarium_records: '#e3305e',
  specialZones: '#adff2f',
  recommended_collection_area: '#333',
  similar_environments_current: '#6336b0',
  similar_environments_future: '#ff6d00' //'#ff8a65'   //  '#ff9100' //'#e23ca8'
});
// CONCATENATED MODULE: ./src/Style.js


var herbarium_records = {
  id: 'herbarium_records',
  source: 'herbarium_records',
  type: 'circle',
  paint: {
    'circle-color': Theme.herbarium_records,
    'circle-stroke-width': 1,
    'circle-stroke-color': '#fff'
  }
};

// Added PDW 2020-08-31
var specialZones = {
  id: 'special_zone',
  source: 'special_zone',
  type: 'fill',
  paint: {
    'fill-color': Theme.specialZones,
    'fill-opacity': 0.5
  }
};

var gdm_prediction = {
  id: 'gdm_prediction',
  source: 'gdm_prediction',
  type: 'fill',
  paint: {
    'fill-color': Theme.recommended_collection_area,
    'fill-opacity': 0.5
  }
};

var gdm_prediction_dark = {
  id: 'gdm_prediction',
  source: 'gdm_prediction',
  type: 'fill',
  paint: {
    'fill-color': '#fff',
    'fill-opacity': 0.7
  }
};

var current_climate_match = {
  id: 'current_climate_match',
  source: 'current_climate_match',
  type: 'fill',
  paint: {
    'fill-color': Theme.similar_environments_current,
    'fill-opacity': 0.3
  }
};

var future_climate_match = {
  id: 'future_climate_match',
  source: 'future_climate_match',
  type: 'fill',
  paint: {
    'fill-color': Theme.similar_environments_future,
    'fill-opacity': 0.3
  }
};

var domain_mask = {
  id: 'domain-mask',
  source: 'domain-mask',
  type: 'fill',
  paint: {
    'fill-color': Theme.recommended_collection_area,
    'fill-opacity': 0.5
  }
};
// EXTERNAL MODULE: ./node_modules/tether/dist/js/tether.js
var tether = __webpack_require__("6BCL");
var tether_default = /*#__PURE__*/__webpack_require__.n(tether);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./src/DefaultMarker.js

/* harmony default export */ var DefaultMarker = (function (options) {
  var element = document.createElement('div');

  // create default map marker SVG
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttributeNS(null, 'height', '41px');
  svg.setAttributeNS(null, 'width', '27px');
  svg.setAttributeNS(null, 'viewBox', '0 0 27 41');

  var markerLarge = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  markerLarge.setAttributeNS(null, 'stroke', 'none');
  markerLarge.setAttributeNS(null, 'stroke-width', '1');
  markerLarge.setAttributeNS(null, 'fill', 'none');
  markerLarge.setAttributeNS(null, 'fill-rule', 'evenodd');

  var page1 = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  page1.setAttributeNS(null, 'fill-rule', 'nonzero');

  var shadow = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  shadow.setAttributeNS(null, 'transform', 'translate(3.0, 29.0)');
  shadow.setAttributeNS(null, 'fill', '#000000');

  var ellipses = [{ 'rx': '10.5', 'ry': '5.25002273' }, { 'rx': '10.5', 'ry': '5.25002273' }, { 'rx': '9.5', 'ry': '4.77275007' }, { 'rx': '8.5', 'ry': '4.29549936' }, { 'rx': '7.5', 'ry': '3.81822308' }, { 'rx': '6.5', 'ry': '3.34094679' }, { 'rx': '5.5', 'ry': '2.86367051' }, { 'rx': '4.5', 'ry': '2.38636864' }];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = get_iterator_default()(ellipses), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var data = _step.value;

      var ellipse = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
      ellipse.setAttributeNS(null, 'opacity', '0.04');
      ellipse.setAttributeNS(null, 'cx', '10.5');
      ellipse.setAttributeNS(null, 'cy', '5.80029008');
      ellipse.setAttributeNS(null, 'rx', data['rx']);
      ellipse.setAttributeNS(null, 'ry', data['ry']);
      shadow.appendChild(ellipse);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var background = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  background.setAttributeNS(null, 'fill', options.color || '#3FB1CE');

  var bgPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  bgPath.setAttributeNS(null, 'd', 'M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z');

  background.appendChild(bgPath);

  var border = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  border.setAttributeNS(null, 'opacity', '0.25');
  border.setAttributeNS(null, 'fill', '#000000');

  var borderPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  borderPath.setAttributeNS(null, 'd', 'M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z');

  border.appendChild(borderPath);

  var maki = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  maki.setAttributeNS(null, 'transform', 'translate(6.0, 7.0)');
  maki.setAttributeNS(null, 'fill', '#FFFFFF');

  var circleContainer = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  circleContainer.setAttributeNS(null, 'transform', 'translate(8.0, 8.0)');

  var circle1 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circle1.setAttributeNS(null, 'fill', '#000000');
  circle1.setAttributeNS(null, 'opacity', '0.25');
  circle1.setAttributeNS(null, 'cx', '5.5');
  circle1.setAttributeNS(null, 'cy', '5.5');
  circle1.setAttributeNS(null, 'r', '5.4999962');

  var circle2 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circle2.setAttributeNS(null, 'fill', '#FFFFFF');
  circle2.setAttributeNS(null, 'cx', '5.5');
  circle2.setAttributeNS(null, 'cy', '5.5');
  circle2.setAttributeNS(null, 'r', '5.4999962');

  circleContainer.appendChild(circle1);
  circleContainer.appendChild(circle2);

  page1.appendChild(shadow);
  page1.appendChild(background);
  page1.appendChild(border);
  page1.appendChild(maki);
  page1.appendChild(circleContainer);

  svg.appendChild(page1);

  element.appendChild(svg);
  return element;
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




window.loadingScreen = Object(build_please_wait["pleaseWait"])({
  backgroundColor: Theme.primary,
  loadingHtml: "<p class='loading-message'>Loading Restore and Renew</p><div class='sk-chasing-dots'><div class='sk-child sk-dot1'></div><div class='sk-child sk-dot2'></div></div>"
});




if (!mapbox_gl_default.a.supported()) {
  window.loadingScreen.updateOption('loadingHtml', "<p class='loading-message'>Restore and Renew</p><p class='loading-message'>You need to upgrade your browser with <a href='https://get.webgl.org/'>WebGL support</a> to use this application.</p>");
}




mapbox_gl_default.a.accessToken = 'pk.eyJ1IjoicmVzdG9yZWFuZHJlbmV3IiwiYSI6ImNqYzlucmtxYjAwbnkyd3F3YXUyMGxsdjMifQ.17jNpwzb5KRvTp7AO4v9Qg';

















var q = query_string_default.a.parse(location.search);

var resultsModalMapIds = ['resultsMapGeneticDiversity', 'resultsMapCurrentClimateMatch', 'resultsMapFutureClimateMatch'];

/* harmony default export */ var App = ({
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this = this;

      window.print = function () {
        this.resultsModal = true;
      }.bind(this);

      if (q.lat && q.lng && q.species && !('edit' in q)) {
        // if a lat,lng,species are provided without the edit flag, skip loading the application and go straight to the results
        this.loadApplication = false;
        this.resultsModal = true;
        this.welcome = false;
        window.loadingScreen.finish();

        // if skipping map loading, then still need to check for speciesTaxon etc.
        if (window.speciesTaxon) {
          this.speciesList = this.speciesList.concat(keys_default()(window.speciesTaxon)).sort();
          this.speciesTaxon = window.speciesTaxon;

          this.checkLoaded('species');
        } else {
          Object(d3_request["a" /* json */])('data/species.json', function (data) {
            _this.speciesList = _this.speciesList.concat(keys_default()(data)).sort();
            _this.speciesTaxon = data;

            _this.checkLoaded('species');
          });
        }
        //json('data/synonyms.json', (data) => {
        //  this.speciesList = this.speciesList.concat(Object.keys(data)).sort();
        //  this.synonyms = data;

        //  this.checkLoaded('synonyms');
        //});
      }

      // Added PDW 2020-08-30
      Object(d3_request["a" /* json */])('data/specialZone.topo.json', function (data) {
        _this.specialZoneGeoJSON = topojson_client["a" /* feature */](data, data.objects.specialZone);
        _this.specialZoneQuery = which_polygon_default()(_this.specialZoneGeoJSON);
        _this.determineInSpecialZone([_this.lng, _this.lat]);
        _this.updateZoneWithCanonicalSpecies(_this.canonicalSpecies);

        _this.checkLoaded('specialZone');
      });

      // Added PDW 2020-08-30
      Object(d3_request["a" /* json */])('data/hasSpecialZone.json', function (data) {
        _this.hasSpecialZone = data;
        _this.updateZoneWithCanonicalSpecies(_this.canonicalSpecies);

        _this.checkLoaded('hasSpecialZone');
      });

      // Added PDW 2020-08-31
      Object(d3_request["a" /* json */])('data/zoneMessages.json', function (data) {
        _this.zoneMessages = data;
        _this.determineInSpecialZone([_this.lng, _this.lat]);
        _this.updateZoneWithCanonicalSpecies(_this.canonicalSpecies);

        _this.checkLoaded('zoneMessages');
      });

      this.tether = new tether_default.a({
        element: '#drawerCollapseButton',
        target: '.v-navigation-drawer',
        attachment: 'top right',
        targetAttachment: 'top right',
        constraints: [{
          to: 'window',
          pin: true
        }],
        offset: '0 -20px'
      });

      var defaultMarkerElements = document.querySelectorAll('.defaultMarker');
      Array.prototype.forEach.call(defaultMarkerElements, function (el) {
        el.appendChild(DefaultMarker({}));
      });

      var self = this;

      if (this.loadApplication) {
        this.map = new mapbox_gl_default.a.Map({
          container: 'map',
          style: 'mapbox:///mapbox/streets-v9',
          center: [147.16, -32.94],
          zoom: 4,
          dragRotate: false
        });
        // fit to NSW
        this.map.fitBounds([139.965, -38.030, 155.258, -27.839], { duration: 0 });

        this.map.addControl(new mapbox_gl_default.a.NavigationControl({
          showCompass: false
        }));

        this.map.addControl(new mapbox_gl_default.a.ScaleControl());

        this.geolocate = new mapbox_gl_default.a.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true
          },
          trackUserLocation: true
        });
        this.geolocate.on('geolocate', function (position) {
          if (!self.lng && !self.lat) {
            self.lng = position.coords.longitude;
            self.lat = position.coords.latitude;
          }

          this.$gtag.event('geolocate_success', {
            event_category: 'interaction',
            event_label: 'geolocate_success'
          });
        });
        this.geolocate.on('error', function () {
          this.$gtag.event('geolocate_error', {
            event_category: 'interaction',
            event_label: 'geolocate_error'
          });
        });
        this.map.addControl(this.geolocate);

        var md = new mobile_detect_default.a(window.navigator.userAgent);
        if (md.mobile()) {
          var click = new window.Event('click');
          setTimeout(function () {
            if (self.geolocate._geolocateButton) {
              self.geolocate._geolocateButton.dispatchEvent(click);
            }
          }, 1000);
        }

        this.map.addControl(new mapbox_gl_geocoder_lib_default.a({
          accessToken: mapbox_gl_default.a.accessToken,
          country: 'au',
          placeholder: 'Find a place'
        }), 'top-left');

        this.marker = new mapbox_gl_default.a.Marker();

        /* URL query params */
        if ('welcome' in q) {
          this.welcome = q.welcome === 'true'; // coerce to boolean
        }
        // the rest can only be set once the map loads

        this.map.on('load', function () {
          _this.mapLoaded = true;
          if (_this.enableLocationSelectionWhenLoaded) {
            _this.map.getCanvasContainer().style.cursor = 'crosshair';
            _this.map.on('click', _this.locationClick);
            _this.enableLocationSelectionWhenLoaded = false;
          }

          /* map load dependent URL query params */
          ['lat', 'lng'].forEach(function (k) {
            if (k in q) {
              self[k] = q[k];
            }
          });

          if ('species' in q) {
            _this.selectedSpecies = q.species;
            // canonical species should be set by watch: selectedSpecies
          }

          if ('speciesInfoModal' in q) {
            _this.speciesInfoModal = q.speciesInfoModal === 'true'; // coerce to boolean
          }

          _this.map.addSource('herbarium_records', {
            type: 'geojson',
            data: _this.emptyGeoJSON
          });
          _this.map.addLayer(herbarium_records, 'waterway-label');

          // Added PDW 2020-08-31
          _this.map.addSource('special_zone', {
            type: 'geojson',
            data: _this.emptyGeoJSON
          });
          _this.map.addLayer(specialZones, 'waterway-label');
          _this.specialZone_state = 'loaded';
          _this.updateZoneWithCanonicalSpecies(_this.canonicalSpecies);

          _this.map.addSource('gdm_prediction', {
            type: 'geojson',
            data: _this.emptyGeoJSON
          });
          _this.map.addLayer(gdm_prediction);
          _this.gdm_predition_state = 'loaded';
          _this.recommended_collection_area_state = 'loaded';

          _this.map.addSource('current_climate_match', {
            type: 'geojson',
            data: _this.emptyGeoJSON
          });
          _this.map.addLayer(current_climate_match, 'housenum-label');
          _this.similar_environments_current_state = 'loaded';

          _this.map.addSource('future_climate_match', {
            type: 'geojson',
            data: _this.emptyGeoJSON
          });
          _this.map.addLayer(assign_default()({}, future_climate_match, { layout: { visibility: 'none' } }), 'current_climate_match');
          _this.similar_environments_future_state = 'loaded';

          _this.map.addSource('domain-mask', {
            type: 'geojson',
            data: _this.emptyGeoJSON
          });
          _this.map.addLayer(domain_mask, 'herbarium_records');
          _this.checkLoaded('map');
        });

        if (window.speciesTaxon) {
          this.speciesList = this.speciesList.concat(keys_default()(window.speciesTaxon)).sort();
          this.speciesTaxon = window.speciesTaxon;

          this.checkLoaded('species');
        } else {
          Object(d3_request["a" /* json */])('data/species.json', function (data) {
            _this.speciesList = _this.speciesList.concat(keys_default()(data)).sort();
            _this.speciesTaxon = data;

            _this.checkLoaded('species');
          });
        }

        //json('data/synonyms.json', (data) => {
        //  this.speciesList = this.speciesList.concat(Object.keys(data)).sort();
        //  this.synonyms = data;

        //  this.checkLoaded('synonyms');
        // });

        Object(d3_request["a" /* json */])('data/domain.topo.json', function (data) {
          _this.domainGeoJSON = topojson_client["a" /* feature */](data, data.objects.domain);
          _this.domainQuery = which_polygon_default()(_this.domainGeoJSON);

          _this.checkLoaded('domain');
        });

        // automatically select link when you click on the input
        document.getElementById('permalink').addEventListener('click', function () {
          var el = document.getElementById('permalink');

          var range, selection;

          if (window.getSelection && document.createRange) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(el);
            selection.removeAllRanges();
            selection.addRange(range);
          } else if (document.selection && document.body.createTextRange) {
            range = document.body.createTextRange();
            range.moveToElementText(el);
            range.select();
          }
        });
      } else {
        if (window.speciesTaxon) {
          this.speciesTaxon = window.speciesTaxon;
        }

        if (window.gdm_prediction) {
          this.gdm_prediction = window.gdm_prediction;
        }

        if (window.gdm_prediction_masked) {
          this.gdm_prediction_masked = window.gdm_prediction_masked;
        }

        if (window.gdm_prediction_bbox) {
          this.gdm_prediction_bbox = window.gdm_prediction_bbox;
        }

        if (window.current_climate_match) {
          this.current_climate_match = window.current_climate_match;
        }

        if (window.future_climate_match) {
          this.future_climate_match = window.future_climate_match;
        }

        ['lat', 'lng'].forEach(function (k) {
          if (k in q) {
            self[k] = q[k];
          }
        });

        if ('species' in q) {
          this.selectedSpecies = q.species;
        }
        if ('canonicalSpecies' in q) {
          this.canonicalSpecies = q.canonicalSpecies;
        }
      }
      new clipboard_default.a('#copyLinkToClipboard');
    });
  },
  data: function data() {
    return {
      welcome: false,
      componentsToLoad: {
        map: true,
        domain: true,
        species: true,
        //synonyms: true,
        specialZone: true,
        hasSpecialZone: true,
        zoneMessages: true
      }, // list of components we expect to load before removing the loading screen

      mapLoaded: false, // changed to true when map has loaded
      enableLocationSelectionWhenLoaded: false, // if the stepper is set to location before the map has loaded, this will be true to set the map up for location selection when it is loaded

      collapsed: false,

      drawer: true,
      step: 1, // initially at step 1 in the process

      canonicalSpecies: null, // canonical species (root species if a synonym was choosen)
      selectedSpecies: null, // selected species (could be a synonym)

      speciesList: [], // populated from remote json, powers species autocomplete select
      speciesTaxon: {}, // populated from remote json
      //synonyms: {}, // populated from remote json

      domainQuery: null, // function for point in polygon test identifying species valid for a location
      speciesForThisLocation: null, // species list for this location
      noSpeciesAtThisLocation: false, // if true, it means there are no species available at the selected location
      noLatLong: true,
      lat: null, // location latitude
      lng: null, // location longitude
      latInput: null, // manually entered latitude
      lngInput: null, // manually entered longitude

      // Added PDW 2020-08-28
      inSpecialZone: false,
      specialZoneIndex: null,
      specialZoneQuery: null,
      specialZoneGeoJSON: null,
      specialZoneSpecies: false,
      zoneMessages: null,
      zoneMessage: null,
      hasSpecialZone: null, // populated from remote json; Added by PDW 2020-08-28
      zone: null, // calculated geojson special zone for this species

      speciesInfoModal: false,
      resultsModal: false,
      zoneMessageModal: false,
      loadApplication: true,

      helpModal: null, // Make helpModal reactive

      speciesPhotoCarouselIndex: 0,

      map_background: 'streets-v10',

      emptyGeoJSON: { type: 'FeatureCollection', features: [] },

      inFlightRequest_downloadResults: null,

      inFlightRequest_herbarium_records: null,
      inFlightRequest_gdm_prediction: null,
      inFlightRequest_current_climate_match: null,
      inFlightRequest_future_climate_match: null,

      data_gdm_prediction: null,
      data_gdm_prediction_masked: null,
      data_current_climate_match: null,
      data_future_climate_match: null,

      resultsError: false,
      resultsErrorMessage: "Error calculating results, however a partial result may be shown. This can happen if the server is experiencing issues, or if you've made too many requests. Wait a minute before trying again.",

      downloadResultsProgress: 0,

      printing: false,

      // validation rules for long/lat input
      // Modified PDW 2018-09-20: enforce item completion of lat or long values before moving to step 2
      longitudeRules: [function (v) {
        return is_finite_default()(Number(v)) || 'Coordinate must be a number';
      }, function (v) {
        return -180 <= Number(v) && Number(v) <= 180 || 'Longitude must be between -180 and 180';
      }, function (v) {
        return !!v || 'A value for Longitude is required';
      }],
      latitudeRules: [function (v) {
        return is_finite_default()(Number(v)) || 'Coordinate must be a number';
      }, function (v) {
        return -90 <= Number(v) && Number(v) <= 90 || 'Latitude must be between -90 and 90';
      }, function (v) {
        return !!v || 'A value for Latitude is required';
      }],

      /* layer states
        - initial - page is still loading disable to prevent toggle before layer exists
        - loaded - new data loaded
      */
      herbarium_records_state: 'initial',
      recommended_collection_area_state: 'initial',
      similar_environments_current_state: 'initial',
      similar_environments_future_state: 'initial',
      specialZone_state: 'initial',

      // layer default toggle states (need to keep this in sync with addLayer initial visibility)
      herbarium_records_toggle: true,
      recommended_collection_area_toggle: true,
      similar_environments_current_toggle: true,
      similar_environments_future_toggle: false
    };
  },

  computed: {
    speciesDropdown: function speciesDropdown() {
      return this.speciesForThisLocation; // || this.speciesList;
    },
    permalink: function permalink() {
      var query = {};
      if (this.lng && this.lat) {
        query.lng = this.lng;
        query.lat = this.lat;
      }
      if (this.canonicalSpecies) {
        query.species = this.canonicalSpecies;
      }
      if (this.selectedSpecies && this.selectedSpecies !== this.canonicalSpecies) {
        query.selectedSpecies = this.selectedSpecies;
      }
      return '/?' + query_string_default.a.stringify(query);
    },
    permalink_display: function permalink_display() {
      return 'https://www.restore-and-renew.org.au' + this.permalink;
    },
    currentDate: function currentDate() {
      return new Date().toString();
    },
    speciesPlantNETurl: function speciesPlantNETurl() {
      if (this.canonicalSpecies in this.speciesTaxon) {
        return this.speciesTaxon[this.canonicalSpecies].plantNETurl;
      } else {
        return null;
      }
    },
    speciesAPCurl: function speciesAPCurl() {
      if (this.canonicalSpecies in this.speciesTaxon) {
        return this.speciesTaxon[this.canonicalSpecies].apcURL;
      } else {
        return null;
      }
    },
    canonicalSpeciesPath: function canonicalSpeciesPath() {
      return this.canonicalSpecies ? this.canonicalSpecies.replace(' ', '_') : null;
    },
    canonicalSpeciesNameFormatted: function canonicalSpeciesNameFormatted() {
      return this.canonicalSpecies in this.speciesTaxon ? this.speciesTaxon[this.canonicalSpecies].nameFormatted : null;
    },
    canonicalSpeciesCommonNames: function canonicalSpeciesCommonNames() {
      return this.canonicalSpecies in this.speciesTaxon ? this.speciesTaxon[this.canonicalSpecies].commonNames : null;
    },
    canonicalSpeciesSynonyms: function canonicalSpeciesSynonyms() {
      return this.canonicalSpecies in this.speciesTaxon ? this.speciesTaxon[this.canonicalSpecies].synonyms.replace(/;/g, ', ') : null;
    },
    canonicalSpeciesSpeciesInfo: function canonicalSpeciesSpeciesInfo() {
      return this.canonicalSpecies in this.speciesTaxon ? this.speciesTaxon[this.canonicalSpecies].speciesInfo : null;
    },
    canonicalSpeciesGeneticsInfo: function canonicalSpeciesGeneticsInfo() {
      return this.canonicalSpecies in this.speciesTaxon ? this.speciesTaxon[this.canonicalSpecies].speciesGeneticsInfo : null;
    },
    showZoneMessage: function showZoneMessage() {
      return this.inSpecialZone && this.hasSpecialZone && this.hasSpecialZone[this.canonicalSpecies] === 'TRUE';
    }
  },
  watch: {
    lng: function lng(val) {
      this.locationUpdated();
    },
    lat: function lat(val) {
      this.locationUpdated();
    },
    lngInput: function lngInput(val) {
      if (!val) {
        this.lng = this.lngInput;
      }
    },
    latInput: function latInput(val) {
      if (!val) {
        this.lat = this.latInput;
      }
    },

    selectedSpecies: function selectedSpecies(val) {
      this.canonicalSpecies = val;
    },

    inSpecialZone: function inSpecialZone(val) {
      if (val && !window.isPrint) {
        if (this.specialZoneSpecies) {
          this.zoneMessageModal = true;
        } else {
          this.zoneMessageModal = false;
        }
      }
    },

    canonicalSpecies: function canonicalSpecies(_canonicalSpecies) {
      var _this2 = this;

      // abort any existing in flight requests
      if (this.inFlightRequest_herbarium_records) {
        this.inFlightRequest_herbarium_records.abort();
        this.inFlightRequest_herbarium_records = null;
      }

      // invalidate the map data so it's not shown while loading
      if (this.map) {
        this.map.getSource('herbarium_records').setData(this.emptyGeoJSON);
        this.map.getSource('special_zone').setData(this.emptyGeoJSON);
      }

      this.updateZoneWithCanonicalSpecies(_canonicalSpecies);

      if (_canonicalSpecies) {
        this.inFlightRequest_herbarium_records = Object(d3_request["a" /* json */])('data/herbarium_records/' + _canonicalSpecies.replace(' ', '_') + '.geojson', function (data) {
          _this2.inFlightRequest_herbarium_records = null;

          _this2.herbarium_records = data;
          if (_this2.map) {
            _this2.map.getSource('herbarium_records').setData(data);
          }
          _this2.herbarium_records_state = 'loaded';

          resultsModalMapIds.forEach(function (map) {
            if (_this2[map] && _this2[map].getSource('herbarium_records')) {
              _this2[map].getSource('herbarium_records').setData(data);
            }
          });
        });

        if (this.lng && this.lat) {
          if (window.isPrint && window.gdm_prediction_masked) {
            // do nothing, since we are printing and have the data already loaded
          } else {
            this.queryModel(this.lng, this.lat, _canonicalSpecies);
          }
        } else {
          // if lng lat not yet set, move the stepper
          this.step = 1;
        }
        if (this.domainGeoJSON && !(this.lng && this.lat)) {
          // only show the domain if choosing a location after selecting a species
          var domain = this.domainGeoJSON.features.find(function (feature) {
            return feature.properties.species == _canonicalSpecies;
          });
          if (domain) {
            if (this.map) {
              this.map.getSource('domain-mask').setData(Object(main_es["a" /* default */])(domain));
            }
          }
        }
      }
    },
    herbarium_records_toggle: function herbarium_records_toggle(val) {
      this.map.setLayoutProperty('herbarium_records', 'visibility', val ? 'visible' : 'none');

      this.$gtag.event('toggle_herbarium_records', {
        event_category: 'interaction',
        event_label: 'Toggle Herbarium Records ' + (val ? 'On' : 'Off')
      });
    },
    recommended_collection_area_toggle: function recommended_collection_area_toggle(val) {
      this.map.setLayoutProperty('gdm_prediction', 'visibility', val ? 'visible' : 'none');

      this.$gtag.event('toggle_recommended_collection_area', {
        event_category: 'interaction',
        event_label: 'Toggle Recommended collection area ' + (val ? 'On' : 'Off')
      });
    },
    similar_environments_current_toggle: function similar_environments_current_toggle(val) {
      this.map.setLayoutProperty('current_climate_match', 'visibility', val ? 'visible' : 'none');

      this.$gtag.event('toggle_similar_environments_current', {
        event_category: 'interaction',
        event_label: 'Toggle Similar environments (Current) ' + (val ? 'On' : 'Off')
      });
    },
    similar_environments_future_toggle: function similar_environments_future_toggle(val) {
      this.map.setLayoutProperty('future_climate_match', 'visibility', val ? 'visible' : 'none');

      this.$gtag.event('toggle_similar_environments_2050', {
        event_category: 'interaction',
        event_label: 'Toggle Similar environments (2050) ' + (val ? 'On' : 'Off')
      });
    },
    map_background: function map_background(val) {
      var _this3 = this;

      var currentStyle = this.map.getStyle();
      Object(d3_request["a" /* json */])('https://api.mapbox.com/styles/v1/mapbox/' + val + '?access_token=' + mapbox_gl_default.a.accessToken, function (style) {
        style.sources = assign_default()({}, currentStyle.sources, style.sources);
        var labelIndex = style.layers.findIndex(function (el) {
          return el.id == 'waterway-label';
        });
        var appLayers = currentStyle.layers.filter(function (el) {
          return el.source && el.source != "mapbox://mapbox.satellite" && el.source != "composite";
        });
        appLayers.reverse();
        appLayers.forEach(function (layer) {
          if (layer.id === 'gdm_prediction') {
            if (val === 'satellite-streets-v10') {
              for (var property in gdm_prediction_dark) {
                layer[property] = gdm_prediction_dark[property];
              }
            } else {
              for (var property in gdm_prediction) {
                layer[property] = gdm_prediction[property];
              }
            }
          }
          style.layers.splice(labelIndex, 0, layer);
        });

        _this3.map.setStyle(style);
      });

      this.$gtag.event('map_background_' + (val === 'streets-v10' ? 'map' : 'satellite'), {
        event_category: 'interaction',
        event_label: 'Map Background change to ' + (val === 'streets-v10' ? 'Map' : 'Satellite')
      });
    },
    resultsModal: function resultsModal(val) {
      var _this4 = this;

      this.waitFor(['gdm_prediction_bbox', 'gdm_prediction_masked', 'current_climate_match', 'future_climate_match'], function () {
        if (val && !_this4.resultsMapGeneticDiversity) {
          // modal opened for the first time
          resultsModalMapIds.forEach(function (map) {
            _this4[map] = new mapbox_gl_default.a.Map({
              container: map,
              style: 'mapbox:///mapbox/streets-v9',
              center: [_this4.lng, _this4.lat],
              zoom: 4,
              interactive: false,
              preserveDrawingBuffer: true
            });
            //setTimeout(() => {
            //}, 1000);

            _this4[map].on('load', function () {
              _this4[map].resize();
              if (_this4.gdm_prediction_bbox) {
                _this4[map].fitBounds(_this4.gdm_prediction_bbox, {
                  padding: 20,
                  duration: 0
                });
              }

              new mapbox_gl_default.a.Marker().setLngLat([_this4.lng, _this4.lat]).addTo(_this4[map]);

              _this4[map].addSource('herbarium_records', {
                type: 'geojson',
                data: _this4.inFlightRequest_herbarium_records ? _this4.emptyGeoJSON : _this4.herbarium_records
              });
              _this4[map].addLayer(herbarium_records, 'waterway-label');

              _this4[map].addSource('special_zone', {
                type: 'geojson',
                data: _this4.zone ? _this4.zone : _this4.emptyGeoJSON
              });
              _this4[map].addLayer(specialZones, 'waterway-label');

              _this4[map].addSource('gdm_prediction', {
                type: 'geojson',
                data: window.gdm_prediction_masked || _this4.map.getSource('gdm_prediction')._data
              });
              _this4[map].addLayer(gdm_prediction);

              if (map === 'resultsMapCurrentClimateMatch') {
                _this4[map].addSource('current_climate_match', {
                  type: 'geojson',
                  data: window.current_climate_match || _this4.map.getSource('current_climate_match')._data
                });
                _this4[map].addLayer(current_climate_match, 'housenum-label');
              }

              if (map === 'resultsMapFutureClimateMatch') {
                _this4[map].addSource('future_climate_match', {
                  type: 'geojson',
                  data: window.future_climate_match || _this4.map.getSource('future_climate_match')._data
                });
                _this4[map].addLayer(future_climate_match, 'housenum-label');
              }
              _this4[map].on('render', function () {
                if (_this4[map].areTilesLoaded() && _this4[map].loaded() && _this4[map].isStyleLoaded() && !_this4['resultsMapReady_' + map]) {
                  _this4['resultsMapReady_' + map] = true;

                  if (_this4.resultsMapReady_resultsMapGeneticDiversity && _this4.resultsMapReady_resultsMapCurrentClimateMatch && _this4.resultsMapReady_resultsMapFutureClimateMatch) {
                    window.resultsMapReady = true;
                  }
                }
              });
            });
          });
        } else if (val) {
          // modal opened subsequent times
          resultsModalMapIds.forEach(function (map) {
            setTimeout(function () {
              _this4[map].resize();
            }, 1000);
          });
        }
      });
    },
    collapsed: function collapsed(_collapsed) {
      this.$gtag.event('panel_' + (_collapsed ? 'closed' : 'opened'), {
        event_category: 'interaction',
        event_label: 'Panel ' + (_collapsed ? 'Closed' : 'Opened')
      });
    }
  },
  methods: {
    determineInSpecialZone: function determineInSpecialZone(ll) {
      // Added PDW 2020-08-31
      var specialZone = this.specialZoneQuery ? this.specialZoneQuery(ll, true) : null;
      if (specialZone) {
        this.inSpecialZone = true;
        this.zoneMessage = this.zoneMessages ? this.zoneMessages[this.canonicalSpecies] : null;
      } else {
        this.inSpecialZone = false;
        this.zoneMessage = null;
      }
    },
    updateZoneWithCanonicalSpecies: function updateZoneWithCanonicalSpecies(canonicalSpecies) {
      if (this.hasSpecialZone && this.hasSpecialZone[canonicalSpecies] === 'TRUE') {
        // PDW 2020-08-30
        this.specialZoneSpecies = true;

        if (this.inSpecialZone) {
          if (!window.isPrint) {
            this.zoneMessageModal = true;
          }
          this.zoneMessage = this.zoneMessages ? this.zoneMessages[canonicalSpecies] : null;
        } else {
          this.zoneMessageModal = false;
          this.zoneMessage = null;
        }

        // fetch special zone polygon(s) from topoJSON object
        this.zone = this.specialZoneGeoJSON ? this.specialZoneGeoJSON.features.find(function (feature) {
          return feature.properties.species == canonicalSpecies;
        }) : null;

        if (this.zone) {
          if (this.map && this.map.getSource('special_zone')) {
            this.map.getSource('special_zone').setData(this.zone);
          }
        }
      } else {
        this.specialZoneSpecies = false;
        if (this.map && this.map.getSource('special_zone')) {
          this.map.getSource('special_zone').setData(this.emptyGeoJSON);
        }
      }
    },
    speciesInfoModalClicked: function speciesInfoModalClicked() {
      this.$gtag.event('species_info_button_clicked', {
        event_category: 'interaction',
        event_label: 'Species Info Button Clicked'
      });
    },
    waitFor: function waitFor(windowVariables, callback) {
      var _this5 = this;

      if (windowVariables.map(function (windowVariable) {
        return window[windowVariable];
      }).every(function (v) {
        return v;
      })) {
        windowVariables.map(function (windowVariable) {
          _this5[windowVariable] = window[windowVariable];
        });
        callback();
      } else {
        setTimeout(function () {
          _this5.waitFor(windowVariables, callback);
        }, 500);
      }
    },
    displayHelpClicked: function displayHelpClicked() {
      // Display a static help page in a new tab
      var helpWindow = window.open();
      helpWindow.document.write(helpPage);

      this.$gtag.event('help', {
        event_category: 'interaction',
        event_label: 'Help'
      });
    },
    downloadResults: function downloadResults() {
      var _this6 = this;

      this.downloadResultsProgress = 0;

      var startTime = window.performance ? performance.now() : null;

      if (this.downloadResultsInterval) {
        window.clearInterval(this.downloadResultsInterval);
        this.downloadResultsInterval = null;
      }

      // tick every 100ms to reach 100% in 10s
      var totalEstimatedTime = 20 * 1000; // 20s as milliseconds
      var intervalDuration = 500; // in milliseconds
      var totalTicks = totalEstimatedTime / intervalDuration;

      this.downloadResultsInterval = window.setInterval(function () {
        _this6.downloadResultsProgress += 100 / totalTicks;
      }, intervalDuration);

      this.inFlightRequest_downloadResults = Object(d3_request["b" /* request */])('/webtool/print').mimeType('application/pdf').header('Content-Type', 'application/json; charset=UTF-8').responseType('blob').post(stringify_default()({

        lng: this.lng,
        lat: this.lat,
        species: this.selectedSpecies,
        canonicalSpecies: this.canonicalSpecies,

        // prefill the data to speed up the processing
        speciesTaxon: this.speciesTaxon,
        gdm_prediction_masked: this.data_gdm_prediction_masked,
        gdm_prediction_bbox: this.gdm_prediction_bbox,
        current_climate_match: this.data_current_climate_match,
        future_climate_match: this.data_future_climate_match
      }), function (err, res) {
        if (err) {
          console.error(err);
        } else {
          var fileName = 'Restore and Renew Results ' + _this6.selectedSpecies + '.pdf';
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(res.response, fileName);
          } else {
            var a = document.createElement("a");
            a.href = window.URL.createObjectURL(res.response);
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
          }
        }
        _this6.inFlightRequest_downloadResults = null;

        if (_this6.downloadResultsInterval) {
          window.clearInterval(_this6.downloadResultsInterval);
          _this6.downloadResultsInterval = null;
        }

        _this6.$gtag.event('download_results_complete', {
          event_category: 'interaction',
          event_label: 'Download Results Complete',
          value: window.performance ? Math.round(performance.now() - startTime) : null
        });
      });

      this.$gtag.event('download_results', {
        event_category: 'interaction',
        event_label: 'Download Results'
      });
    },
    submitClicked: function submitClicked() {
      // User has manually entered lat/long values: pass them over to this.lat and this.lng which will trigger map marker placement, etc
      this.lat = this.latInput;
      this.lng = this.lngInput;

      this.$gtag.event('set_location_via_coordinates', {
        event_category: 'interaction',
        event_label: 'Set Location via Coordinates'
      });
    },
    // given a component just finished loading, check if there are any more components to load, and if not, remove the loading screen
    checkLoaded: function checkLoaded(componentJustCompleted) {
      this.componentsToLoad[componentJustCompleted] = false;

      var allLoaded = values_default()(this.componentsToLoad).reduce(function (acc, cur) {
        return acc || cur;
      }, false);
      if (allLoaded) {
        window.loadingScreen.finish();
      }
    },
    reset: function reset(e) {
      var _this7 = this;

      this.selectedSpecies = null;
      this.lng = null;
      this.lat = null;
      this.lngInput = null;
      this.latInput = null;
      this.noSpeciesAtThisLocation = false;
      this.noLatLong = true;
      this.inSpecialZone = false;
      this.specialZoneSpecies = false;

      // go to location step
      this.step = 1;

      // abort any existing in flight requests
      ['gdm_prediction', 'current_climate_match', 'future_climate_match'].forEach(function (i) {
        if (_this7['inFlightRequest_' + i]) {
          _this7['inFlightRequest_' + i].abort();
          _this7['inFlightRequest_' + i] = null;
        }
      });

      this.$gtag.event('reset', {
        event_category: 'interaction',
        event_label: 'Reset'
      });
    },
    drawerCollapseToggled: function drawerCollapseToggled(e) {
      if (e.propertyName == 'transform') {
        this.tether.position();
        if (this.map) this.map.resize();
      }
    },
    print: function print() {
      // print the results modal
      this.printing = true;
      var self = this;
      var bounds = {};

      function renderEvent() {
        var isEveryMapLoaded = resultsModalMapIds.map(function (map) {
          return self[map].loaded();
        }).every(function (v) {
          return v;
        });

        if (isEveryMapLoaded) {
          resultsModalMapIds.map(function (map) {
            self[map].off('render', renderEvent);
          });

          setTimeout(function () {
            window.print();
            document.getElementById('app').removeAttribute('style');
            resultsModalMapIds.map(function (map) {
              document.getElementById(map).removeAttribute('style');
              self[map].resize();
              self[map].fitBounds(bounds[map], {
                padding: 0,
                linear: true,
                duration: 0
              });
            });

            self.printing = false;
          }, 2000);
        }
      }

      // set the page size as A4 Landscape
      document.getElementById('app').setAttribute('style', 'width: 29.7cm;');

      resultsModalMapIds.map(function (map) {
        bounds[map] = self[map].getBounds();
      });
      resultsModalMapIds.map(function (map) {
        self[map].on('render', renderEvent);
        document.getElementById(map).setAttribute('style', 'height: 18cm;');

        self[map].resize();
        self[map].fitBounds(bounds[map], {
          padding: 0,
          linear: true,
          duration: 0
        });
      });
    },
    locationUpdated: lodash_default.a.debounce(function () {
      var _this8 = this;

      if (this.lng && this.lat) {
        var ll = [this.lng, this.lat];
        // set marker location

        // We have lat/long values so unset the noLatLong flag
        this.noLatLong = false;

        if (this.domainQuery) {
          var domains = this.domainQuery(ll, true);
          if (domains) {
            this.noSpeciesAtThisLocation = false;
            this.speciesForThisLocation = domains.map(function (domain) {
              return domain.species;
            }).sort();

            this.determineInSpecialZone(ll);

            // FIXME if canonicalSpecies already set put into an error state
            console.log("domainQuery before setting this.step = 2");
            this.step = 2;
          } else {
            // no domains found for this location
            this.noSpeciesAtThisLocation = true;
            this.speciesForThisLocation = [];
          }
        }

        if (this.map) {
          this.marker.setLngLat(ll).addTo(this.map);
          this.map.easeTo({
            center: ll
          });
        }

        if (this.canonicalSpecies) {
          if (this.map) this.queryModel(this.lng, this.lat, this.canonicalSpecies);
        }
      } else {
        // remove from map
        if (this.marker) this.marker.remove();

        ['gdm_prediction', 'current_climate_match', 'future_climate_match'].forEach(function (i) {
          if (_this8['inFlightRequest_' + i]) {
            _this8['inFlightRequest_' + i].abort();
            _this8['inFlightRequest_' + i] = null;
          }

          // invalidate any data on the map since one of the location values is not set yet
          if (_this8.map) _this8.map.getSource(i).setData(_this8.emptyGeoJSON);

          // Remove previous speciesAtThisLocation items
          _this8.speciesForThisLocation = [];

          // Set flag warning of no lat/long
          _this8.noLatLong = true;
        });
      }
    }, 100),
    /**
     * Set up the map to handle setting the location for restoration
     *
     * Including:
     *  - clicking on the map
     *  - result from search
     *  - geolocation
     */
    enableLocationSelection: function enableLocationSelection() {
      if (this.mapLoaded) {
        this.map.getCanvasContainer().style.cursor = 'crosshair';
        this.map.on('click', this.locationClick);
      } else {
        this.enableLocationSelectionWhenLoaded = true;
      }
    },

    /**
     * Unset handlers from enableLocationSelection
     */
    disableLocationSelection: function disableLocationSelection() {
      if (this.map) {
        this.map.getCanvasContainer().style.cursor = 'auto';
        this.map.off('click', this.locationClick);
      }
    },

    locationClick: function locationClick(e) {
      this.lng = e.lngLat.lng.toFixed(6);
      this.lat = e.lngLat.lat.toFixed(6);
      this.latInput = this.lat;
      this.lngInput = this.lng;

      this.$gtag.event('set_location_via_map', {
        event_category: 'interaction',
        event_label: 'Set Location via Map'
      });
    },

    stepperChanged: function stepperChanged(step) {
      step == 1 ? this.enableLocationSelection() : this.disableLocationSelection();
    },

    queryModel: function queryModel(lng, lat, taxonName) {
      var _this9 = this;

      this.resultsError = false;

      // abort any existing in flight requests
      ['gdm_prediction', 'current_climate_match', 'future_climate_match'].forEach(function (i) {
        if (_this9['inFlightRequest_' + i]) {
          _this9['inFlightRequest_' + i].abort();
          _this9['inFlightRequest_' + i] = null;
        }

        // invalidate any data on the map while loading
        if (_this9.map) _this9.map.getSource(i).setData(_this9.emptyGeoJSON);
      });

      // go to results step
      this.step = 3;
      if (this.map) this.map.getSource('domain-mask').setData(this.emptyGeoJSON); // FIXME this should be more robust for corner cases

      ['gdm_prediction', 'current_climate_match', 'future_climate_match'].forEach(function (i) {
        _this9['inFlightRequest_' + i] = Object(d3_request["b" /* request */])('/api/' + i.replace(/_/g, '-')).mimeType('application/json').header('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8').post(query_string_default.a.stringify({
          longitude: lng,
          latitude: lat,
          taxonName: '"' + taxonName + '"'
        }), function (err, xhr) {
          _this9['inFlightRequest_' + i] = null;
          if (err) {
            _this9.resultsError = true;
            console.error(err);
          } else {
            var geojson = JSON.parse(xhr.responseText);
            _this9['data_' + i] = geojson;
            window[i] = geojson;

            if (i == 'gdm_prediction') {
              _this9.gdm_prediction_bbox = bbox_default()(geojson);
              window.gdm_prediction_bbox = _this9.gdm_prediction_bbox;
              if (_this9.map) {
                _this9.map.fitBounds(_this9.gdm_prediction_bbox, {
                  duration: 0,
                  padding: 20
                });
              }

              var combined = combine_default()(geojson);
              if (combined && combined.features && combined.features.length) {
                _this9['data_' + i + '_masked'] = Object(difference_main_es["a" /* default */])({
                  "type": "Feature",
                  "properties": {},
                  "geometry": {
                    "type": "Polygon",
                    "coordinates": [[[180, 90], [180, -90], [-180, -90], [-180, 90], [180, 90]]]
                  }
                }, combined.features[0]);
                window[i + '_masked'] = _this9['data_' + i + '_masked'];
                if (combined.features.length != 1) {
                  console.error("Combine created too many features: ", combined);
                }
              } else {
                console.error("Couldn't combine GeoJSON: ", geojson);
              }
              if (_this9.map) _this9.map.getSource(i).setData(_this9['data_' + i + '_masked'] || _this9['data_' + i]);
            } else {
              if (_this9.map) _this9.map.getSource(i).setData(geojson);
            }
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cb031d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-dialog',{attrs:{"max-width":"1000px"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.welcome = false}},model:{value:(_vm.welcome),callback:function ($$v) {_vm.welcome=$$v},expression:"welcome"}},[_c('v-card',{staticClass:"text-xs-center"},[_c('v-card-text',[_c('p',[_c('img',{staticStyle:{"max-height":"400px","max-width":"100%","cursor":"pointer"},attrs:{"src":__webpack_require__("sqv7")},on:{"click":function($event){$event.stopPropagation();_vm.welcome = false}}})]),_vm._v(" "),_c('v-alert',{attrs:{"color":"blue","value":true}},[_vm._v("Twenty six species now available")]),_vm._v(" "),_c('p',[_vm._v("Restore & Renew responds to the need for ecological restoration practitioners to incorporate the latest science into their toolkit, helping them to restore diverse, resilient and adaptable ecosystems.")]),_vm._v(" "),_c('p',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.welcome = false}}},[_vm._v("Enter Restore & Renew webtool")])],1),_vm._v(" "),_c('p',[_vm._v("More information about the Restore & Renew project is available "),_c('a',{attrs:{"href":"https://www.rbgsyd.nsw.gov.au/science/restore-renew"}},[_vm._v("here")]),_vm._v(", or email us at "),_c('a',{attrs:{"href":"mailto:Restore.Renew@rbgsyd.nsw.gov.au"}},[_vm._v("Restore.Renew@rbgsyd.nsw.gov.au")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Thanks to The NSW Environmental Trust, HSBC and DArT for their support of this project:")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"http://www.environment.nsw.gov.au/grants/envtrust.htm"}},[_c('img',{staticClass:"welcome-sponsor-logos",attrs:{"src":__webpack_require__("I6Jg")}})]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"http://www.about.hsbc.com.au/"}},[_c('img',{staticClass:"welcome-sponsor-logos",attrs:{"src":__webpack_require__("xFFW")}})]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"http://www.diversityarrays.com"}},[_c('img',{staticClass:"welcome-sponsor-logos",attrs:{"src":__webpack_require__("Y22I")}})])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"content-class":"infoModal","max-width":"1200px"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.speciesInfoModal = false}},model:{value:(_vm.speciesInfoModal),callback:function ($$v) {_vm.speciesInfoModal=$$v},expression:"speciesInfoModal"}},[_c('v-card',[_c('v-card-text',{staticClass:"py-0"},[_c('v-alert',{attrs:{"outline":"","color":"blue","value":true}},[_vm._v("\n          The information provided here is reproduced in the results document which you can download as a pdf.\n        ")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"headline"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.canonicalSpeciesNameFormatted)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.speciesInfoModal = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"py-0"},[(_vm.canonicalSpeciesCommonNames)?_c('p',[_c('b',[_vm._v("Common names:")]),_vm._v("Common names: "+_vm._s(_vm.canonicalSpeciesCommonNames))]):_vm._e(),_vm._v(" "),(_vm.canonicalSpeciesSynonyms)?_c('p',[_c('b',[_vm._v("Synonyms:")]),_vm._v(" "+_vm._s(_vm.canonicalSpeciesSynonyms))]):_vm._e(),_vm._v(" "),(_vm.specialZoneSpecies)?_c('p',{staticStyle:{"color":"Tomato"}},[_c('b',[_vm._v("NOTE:")]),_vm._v(" This species includes one or more areas in which special conditions apply to the collection or handling of the species, or parts of it such as seeds. These special zones are highlighted on the maps produced by this webtool.")]):_vm._e(),_vm._v(" "),(_vm.showZoneMessage)?_c('p',{staticStyle:{"color":"Tomato"},domProps:{"innerHTML":_vm._s(_vm.zoneMessage)}}):_vm._e(),_vm._v(" "),(_vm.canonicalSpeciesSpeciesInfo)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.canonicalSpeciesSpeciesInfo)}}):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-center",attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":""}},[_c('figure',[(_vm.canonicalSpeciesPath)?_c('img',{attrs:{"src":'data/images/species/' + _vm.canonicalSpeciesPath + '_distribution.png',"alt":_vm.canonicalSpecies + ' distribution'}}):_vm._e(),_vm._v(" "),_c('figcaption',{staticStyle:{"font-size":"85%"}},[_vm._v("Herbarium records (Sourced from ALA)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"sm6":""}},[(_vm.canonicalSpecies in _vm.speciesTaxon && _vm.speciesTaxon[_vm.canonicalSpecies].photos)?_c('div',[(_vm.speciesTaxon[_vm.canonicalSpecies].photos.length == 1)?_c('div',[_c('figure',[(_vm.canonicalSpeciesPath)?_c('img',{attrs:{"src":'data/images/species/' + _vm.speciesTaxon[_vm.canonicalSpecies].photos[0].file,"alt":_vm.canonicalSpecies}}):_vm._e(),_vm._v(" "),_c('figcaption',{staticStyle:{"font-size":"85%"}},[_vm._v(_vm._s(_vm.speciesTaxon[_vm.canonicalSpecies].photos[0].caption))])])]):_c('div',[_c('figure',[_c('v-carousel',{attrs:{"cycle":false},model:{value:(_vm.speciesPhotoCarouselIndex),callback:function ($$v) {_vm.speciesPhotoCarouselIndex=$$v},expression:"speciesPhotoCarouselIndex"}},_vm._l((_vm.speciesTaxon[_vm.canonicalSpecies].photos),function(photo,i){return _c('v-carousel-item',{key:i,attrs:{"src":'data/images/species/' + photo.file}})}),1)],1),_vm._v(" "),_c('figcaption',{staticStyle:{"font-size":"85%","margin-top":"5px"}},[_vm._v(_vm._s(_vm.speciesTaxon[_vm.canonicalSpecies].photos[_vm.speciesPhotoCarouselIndex].caption))])])]):_c('div',[_c('figure',[_c('img',{attrs:{"src":"data/images/species/placeholder.png","alt":"No image available"}})])])])],1),_vm._v(" "),_c('v-divider',{staticClass:"my-3"})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.speciesInfoModal=false}}},[_vm._v("Close")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"content-class":"infoModal","fullscreen":""},model:{value:(_vm.helpModal),callback:function ($$v) {_vm.helpModal=$$v},expression:"helpModal"}}),_vm._v(" "),_c('v-dialog',{attrs:{"content-class":"infoModal resultsModal","fullscreen":""},model:{value:(_vm.resultsModal),callback:function ($$v) {_vm.resultsModal=$$v},expression:"resultsModal"}},[_c('v-card',[_c('v-card-text',[_c('div',{staticClass:"printSection"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-card-text',{staticClass:"py-0"},[_c('v-alert',{attrs:{"outline":"","color":"black","value":true}},[_c('p',[_vm._v("This document is to support you in making decisions about your restoration project. It provides the following information:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("A brief species description of your selected species")]),_vm._v(" "),_c('li',[_vm._v("An interpretation of the distribution of environmental suitability for the selected species, and how this distribution is expected to change in the future")]),_vm._v(" "),_c('li',[_vm._v("The geographic area representing the "),_c('i',[_vm._v("local genetic provenance")]),_vm._v(" for this species at the site you selected")]),_vm._v(" "),_c('li',[_vm._v("The distribution of current and future climatic conditions that are representative of your selected site")]),_vm._v(" "),_c('li',[_vm._v("Suggestions on how to implement a range of restoration scenarios")])]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p',[_c('b',[_vm._v("Please note:")]),_vm._v(" The Restore & Renew project uses species names from the National Species List (NSL) maintained by the Atlas of Living Australia. The plant names on the NSL are derived from the Australian Plant Census maintained by the Council of Heads of Australasian Herbaria (CHAH).")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('figure',[_c('img',{attrs:{"src":__webpack_require__("7Otq"),"alt":"Restore & Renew logo"}})])])],1),_vm._v(" "),_c('v-card-title',{staticClass:"headline"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.canonicalSpeciesNameFormatted)}})]),_vm._v(" "),_c('v-card-text',{staticClass:"py-0"},[(_vm.canonicalSpeciesCommonNames)?_c('p',[_c('b',[_vm._v("Common names:")]),_vm._v("Common names: "+_vm._s(_vm.canonicalSpeciesCommonNames))]):_vm._e(),_vm._v(" "),(_vm.canonicalSpeciesSynonyms)?_c('p',[_c('b',[_vm._v("Synonyms:")]),_vm._v(" "+_vm._s(_vm.canonicalSpeciesSynonyms))]):_vm._e(),_vm._v(" "),(_vm.specialZoneSpecies)?_c('p',{staticStyle:{"color":"Tomato"}},[_c('b',[_vm._v("NOTE:")]),_vm._v(" This species includes one or more areas in which special conditions apply to the collection or handling of the species, or parts of it such as seeds. These special zones are highlighted on the maps produced by this webtool.")]):_vm._e(),_vm._v(" "),(_vm.showZoneMessage)?_c('p',{staticStyle:{"color":"Tomato"},domProps:{"innerHTML":_vm._s(_vm.zoneMessage)}}):_vm._e(),_vm._v(" "),(_vm.canonicalSpeciesSpeciesInfo)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.canonicalSpeciesSpeciesInfo)}}):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-center avoid-page-break",attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":""}},[_c('figure',[(_vm.canonicalSpeciesPath)?_c('img',{attrs:{"src":'data/images/species/' + _vm.canonicalSpeciesPath + '_distribution.png',"alt":_vm.canonicalSpecies + ' distribution'}}):_vm._e(),_vm._v(" "),_c('figcaption',{staticStyle:{"font-size":"85%"}},[_vm._v("Herbarium records (Sourced from ALA)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"sm6":""}},[(_vm.canonicalSpecies in _vm.speciesTaxon && _vm.speciesTaxon[_vm.canonicalSpecies].photos)?_c('div',[(_vm.speciesTaxon[_vm.canonicalSpecies].photos.length == 1)?_c('div',[_c('figure',[(_vm.canonicalSpeciesPath)?_c('img',{attrs:{"src":'data/images/species/' + _vm.speciesTaxon[_vm.canonicalSpecies].photos[0].file,"alt":_vm.canonicalSpecies}}):_vm._e(),_vm._v(" "),_c('figcaption',{staticStyle:{"font-size":"85%"}},[_vm._v(_vm._s(_vm.speciesTaxon[_vm.canonicalSpecies].photos[0].caption))])])]):_c('div',[_c('figure',[_c('v-carousel',{attrs:{"cycle":false},model:{value:(_vm.speciesPhotoCarouselIndex),callback:function ($$v) {_vm.speciesPhotoCarouselIndex=$$v},expression:"speciesPhotoCarouselIndex"}},_vm._l((_vm.speciesTaxon[_vm.canonicalSpecies].photos),function(photo,i){return _c('v-carousel-item',{key:i,attrs:{"src":'data/images/species/' + photo.file}})}),1)],1),_vm._v(" "),_c('figcaption',{staticStyle:{"font-size":"85%","margin-top":"5px"}},[_vm._v(_vm._s(_vm.speciesTaxon[_vm.canonicalSpecies].photos[_vm.speciesPhotoCarouselIndex].caption))])])]):_c('div',[_c('figure',[_c('img',{attrs:{"src":"data/images/species/placeholder.png","alt":"No image available"}})])])])],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"my-3"}),_vm._v(" "),_c('div',{staticClass:"printSection"},[_c('h2',[_vm._v("Summary of genetic findings")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.canonicalSpeciesGeneticsInfo)}})]),_vm._v(" "),_c('v-divider',{staticClass:"my-3"}),_vm._v(" "),_c('div',{staticClass:"printSection"},[_c('h2',[_vm._v("Collection and restoration scenarios")]),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('div',{staticClass:"defaultMarker"})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Selected location")]),_vm._v(" "),(_vm.lng && _vm.lat)?_c('v-list-tile-sub-title',[_vm._v("Latitude: "+_vm._s(_vm.lat)+", Longitude: "+_vm._s(_vm.lng))]):_vm._e()],1)],1),_vm._v(" "),_c('p',[_vm._v("For your selected species and location, you have a number restoration scenarios to choose amongst. Each section below gives advice on how to follow each one using our current understanding of how genetic diversity for this species varies across the landscape.")]),_vm._v(" "),_c('v-alert',{attrs:{"outline":"","color":"error","value":true}},[_c('b',[_vm._v("You may need to obtain collecting permits from relevant authorities, as well as obtaining permission to enter private properties.")])])],1),_vm._v(" "),_c('v-divider',{staticClass:"my-3"}),_vm._v(" "),_c('div',{staticClass:"printSection"},[_c('h3',[_vm._v("Local provenance scenario")]),_vm._v(" "),_c('v-layout',{staticClass:"section",attrs:{"row":""}},[_c('v-flex',{staticClass:"pr-4",attrs:{"sm6":""}},[_c('p',[_vm._v("The un-greyed region on the map is the 'genetically local area' or local neighbourhood, based on genetic data.")]),_vm._v(" "),_c('p',[_vm._v("If the objective of your project is to restore this species from local provenance only, where possible, we encourage collection of material from multiple locations within the local provenance area to increase genetic variation, overall fitness and long-term viability of your restoration project.")]),_vm._v(" "),_c('p',[_vm._v("In general, when sampling plant material for restoration, sampling from a greater number of individuals and from individuals further apart within the genetic neighbourhood will lead to greater genetic diversity. The graph below (based on a modelled simulation) shows that we can expect the genetic diversity captured to increase as more plants are collected, especially if the plants are far enough apart (thus decreasing the likelihood of them being closely related). The blue curve shows an outcome for a \"mixed\" strategy, where half the plants are collected near the restoration site, and the other half were collected from a site at the boundary of the local neighbourhood. Such a strategy produces greater diversity than collecting the same number of plants from the same location (red curve).")]),_vm._v(" "),_c('p',[_vm._v("The blue curve shows an outcome for a sampling strategy that is not restricted to a single location. In this case, as an example, half the plants were collected from a location near the restoration site, and the other half were collected from a location close to the boundary of the local genetic provenance. Such a strategy produces much greater diversity (blue curve) than collecting the same number of plants from the same location (red curve). So even when restricting your sampling to the ‘local provenance’, it is generally best to sample from multiple individuals sourced from multiple locations. Although the extent of local provenance varies between locations and species, opportunities to maximise diversity are generally present.")]),_vm._v(" "),_c('v-layout',{staticClass:"avoid-page-break",attrs:{"row":""}},[_c('img',{attrs:{"src":"data/images/diversitySamplingCurve.png","alt":"Diversity-sampling curve","width":"344","height":"500"}}),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('div',{staticClass:"defaultMarker small"})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Selected location")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"herbarium_records","small":""}},[_vm._v("lens")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Herbarium records")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('em',[_vm._v("Sourced from ALA")])])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"recommended_collection_area"}},[_vm._v("cloud_circle")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Recommended collection area")])],1)],1)],1)],1),_vm._v(" "),_c('p',[_vm._v("For your selected species and location there are additional restoration strategies to choose from other than the basic ‘local provenance’ scenario described above. The section below suggests how to follow additional scenarios using our current understanding of how genetic diversity varies across the landscape for this species.")])],1),_vm._v(" "),_c('v-flex',{attrs:{"sm6":""}},[_c('div',{staticClass:"map",attrs:{"id":"resultsMapGeneticDiversity"}})])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"my-3"}),_vm._v(" "),_c('div',{staticClass:"printSection"},[_c('h3',[_vm._v("Matched local climate scenarios")]),_vm._v(" "),_c('v-layout',{staticClass:"section",attrs:{"row":""}},[_c('v-flex',{staticClass:"pr-4",attrs:{"sm6":""}},[_c('p',[_vm._v("The areas that match the climate at your chosen site are shown shaded in purple. It is possible that this species has made subtle adaptations to the local environment. We cannot determine the degree of local adaptation with currently available genetic samples; it typically requires extensive experimental study. To make allowance for possible local adaptation, you may decide to collect material from similar environments to that present at your selected location. This information enables you to plan one or more replicable ‘composite provenancing’ strategy/ies that can be fitted within a comparative experimental model, or can be planned as a ‘one-off’ and monitored through time. Three possible scenarios include: ")]),_vm._v(" "),_c('ol',[_c('li',[_c('b',[_vm._v("Local provenance, local climate")]),_vm._v(": if you aim to plant genetically local material that fits climate (currently) similar to your selected site, collect from multiple locations in the following areas:\n                    "),_c('ul',[_c('li',[_vm._v("The areas that fall within the overlap between the local genetic provenance (non-greyed area on the map), and the climate matched regions (highlighted in purple).")])])]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Local composite")]),_vm._v(": if you aim to plant genetically local material, but include the range of climatic conditions present within your local genetic provenance, collect from multiple locations in the two areas described below:\n                    "),_c('ul',[_c('li',[_vm._v("The local genetic provenance sites (non-greyed area on the map) that fall within climatic conditions that are matched to your selected site (purple highlight).")]),_vm._v(" "),_c('li',[_vm._v("The local genetic provenance sites (non-greyed area on the map) that fall outside matched climatic conditions.")])])]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Mixed composite")]),_vm._v(": if you aim to collect plant material from climatic conditions similar to those at your site but from multiple genetic provenances, collect from multiple locations in the two areas described below:\n                    "),_c('ul',[_c('li',[_vm._v("The overlap between the local genetic provenance (non-greyed area on the map), and regions climatically matched to your selected site (highlighted in purple).")]),_vm._v(" "),_c('li',[_vm._v("Areas climatically matching the conditions on your selected site but found outside the local genetic provenance (highlighted in purple within the greyed area).")])])])]),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('div',{staticClass:"defaultMarker small"})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Selected location")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"herbarium_records","small":""}},[_vm._v("lens")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Herbarium records")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('em',[_vm._v("Sourced from ALA")])])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"recommended_collection_area"}},[_vm._v("cloud_circle")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Recommended collection area")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"similar_environments_current"}},[_vm._v("stop")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Simlar environments (Current)")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticStyle:{"padding-left":"31px"}},[_c('em',[_vm._v("(Matches current site conditions)")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm6":""}},[_c('div',{staticClass:"map",attrs:{"id":"resultsMapCurrentClimateMatch"}})])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"my-3"}),_vm._v(" "),_c('div',{staticClass:"printSection"},[_c('h3',[_vm._v("Matched to future climate scenarios")]),_vm._v(" "),_c('v-layout',{staticClass:"section",attrs:{"row":""}},[_c('v-flex',{staticClass:"pr-4",attrs:{"sm6":""}},[_c('v-card',[_c('p',[_vm._v("The areas highlighted in orange on this map show areas that match the climatic conditions predicted for "),_c('i',[_vm._v("your")]),_vm._v(" selected site in 2050, but are present in the landscape "),_c('i',[_vm._v("now")]),_vm._v(". If you aim to plant ‘climate ready’ material that is matched to the conditions predicted to prevail at your site in the future (potentially pre-adapted to these future conditions), include collections from areas highlighted in orange.  Two possible ‘climate ready’ scenarios include:")]),_vm._v(" "),_c('ol',[_c('li',[_c('b',[_vm._v("Local provenance, climate adjusted")]),_vm._v(": If you aim to plant genetically local material fitting the conditions predicted for your selected restoration site in the future, collect from multiple locations in the following area:\n                    "),_c('ul',[_c('li',[_vm._v("Areas matching the local genetic provenance area with future predicted conditions (orange highlights within non-greyed areas). Note future-matched conditions are not always available within the local provenance area.")])])]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Predictive")]),_vm._v(": If you aim to plant material fitting the conditions predicted for your selected restoration site in the future, but not only sourced from the local genetic provenance, collect from multiple locations in the two areas described below:\n                  "),_c('ul',[_c('li',[_vm._v("Areas matching the local genetic provenance area with future predicted conditions (orange highlights within non-greyed areas). Note future-matched conditions are not always available within the local provenance area.")]),_vm._v(" "),_c('li',[_vm._v("Areas matching the conditions predicted for your site in the future but outside the local genetic provenance (i.e. intersection between orange highlights and greyed areas of the map).")])])])])]),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('div',{staticClass:"defaultMarker small"})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Selected location")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"herbarium_records","small":""}},[_vm._v("lens")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Herbarium records")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('em',[_vm._v("Sourced from ALA")])])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"recommended_collection_area"}},[_vm._v("cloud_circle")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Recommended collection area")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"similar_environments_future"}},[_vm._v("stop")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Similar environments (2050)")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticStyle:{"padding-left":"31px"}},[_c('em',[_vm._v("(Matches future conditions at site in 2050)")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm6":""}},[_c('div',{staticClass:"map",attrs:{"id":"resultsMapFutureClimateMatch"}})])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"my-3"}),_vm._v(" "),_c('p',{staticClass:"text-xs-center"},[_vm._v("Text and images © 2020 NSW Government")]),_vm._v(" "),_c('span',{staticClass:"print permalink-print"},[_vm._v("Printed from "+_vm._s(_vm.permalink_display)+" on "+_vm._s(_vm.currentDate))])],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-5 resultActions"},[_c('v-container',{staticClass:"shareLink",attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"permalink-box",attrs:{"xs10":""}},[_c('span',{attrs:{"id":"permalink"}},[_vm._v(_vm._s(_vm.permalink_display))])]),_vm._v(" "),(false)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","id":"copyLinkToClipboard","flat":"","icon":"","color":"primary","data-clipboard-target":"#permalink"},slot:"activator"},[_c('v-icon',[_vm._v("content_copy")])],1),_vm._v(" "),_c('span',[_vm._v("Copy link to clipboard")])],1)],1):_vm._e()],1),_vm._v(" "),_c('p',{staticClass:"caption shareLink"},[_vm._v("Copy and paste this link to share the current view")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","loading":_vm.printing,"disabled":_vm.printing},on:{"click":_vm.print}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("print")]),_vm._v("\n          Print\n        ")],1)],1)],1)],1),_vm._v(" "),(!_vm.resultsModal)?_c('v-dialog',{attrs:{"content-class":"infoModal","max-width":"800px"},model:{value:(_vm.zoneMessageModal),callback:function ($$v) {_vm.zoneMessageModal=$$v},expression:"zoneMessageModal"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline red lighten-2"},[_vm._v("About your selected site...\n        "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.zoneMessageModal = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.zoneMessage)}})]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.zoneMessageModal=false}}},[_vm._v("I accept")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"fixed":"","permanent":"","width":"400","app":"","mini-variant":_vm.collapsed,"mini-variant-width":"60"},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-container',[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("7Otq"),"alt":"Restore and Renew"}})])]),_vm._v(" "),_c('v-container',{staticClass:"pt-0"},[_c('v-btn',{staticClass:"pa-2 mb-4",attrs:{"color":"primary","outline":"","block":"","href":"/"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("home")]),_vm._v("\n        Return to main site\n      ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"info"},on:{"click":function($event){_vm.displayHelpClicked()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("help")]),_vm._v("Help")],1),_vm._v(" "),_c('span',[_vm._v("Opens in a new tab")])],1),_vm._v(" "),_c('v-stepper',{attrs:{"vertical":"","non-linear":""},on:{"input":_vm.stepperChanged},model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-step',{attrs:{"step":"1","complete":(_vm.lat && _vm.lng) ? true : false,"editable":"","rules":[function () { return !this$1.noSpeciesAtThisLocation } ]}},[_vm._v("\n        Location\n        "),_c('small',[_vm._v("Choose a location for restoration")])]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('p',[_vm._v("Click on a location on the map or enter WGS84 coordinates")]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Latitude","clearable":"","rules":_vm.latitudeRules},model:{value:(_vm.latInput),callback:function ($$v) {_vm.latInput=$$v},expression:"latInput"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Longitude","clearable":"","rules":_vm.longitudeRules},model:{value:(_vm.lngInput),callback:function ($$v) {_vm.lngInput=$$v},expression:"lngInput"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.submitClicked()}}},[_vm._v("Submit\n        ")]),_vm._v(" "),_c('v-alert',{attrs:{"filled":"","color":"error","icon":"warning","value":_vm.noSpeciesAtThisLocation}},[_c('strong',[_vm._v("Currently no data available for this location.")])])],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.selectedSpecies ? true : false,"editable":""}},[_vm._v("\n        Species\n        "),_c('small',[_vm._v("Choose a species for restoration")])]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-autocomplete',{staticClass:"mb-2",attrs:{"items":_vm.speciesDropdown,"label":"Species name","dense":"","no-data-text":"null","hint":"Only species with genetic data for your location are shown","persistent-hint":""},model:{value:(_vm.selectedSpecies),callback:function ($$v) {_vm.selectedSpecies=$$v},expression:"selectedSpecies"}}),_vm._v(" "),_c('v-alert',{attrs:{"filled":"","color":"warning","icon":"warning","value":_vm.noLatLong}},[_c('strong',[_vm._v("Please return to Step 1 and select a location.")])])],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3","complete":(_vm.lng && _vm.lat && _vm.selectedSpecies) ? true : false,"editable":"","edit-icon":"check"}},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs10":""}},[_vm._v("\n            Results"),_c('br'),_vm._v(" "),_c('small',[_vm._v("View results")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-avatar',{attrs:{"size":"36px"}},[_c('v-progress-circular',{directives:[{name:"show",rawName:"v-show",value:((_vm.inFlightRequest_gdm_prediction || _vm.inFlightRequest_current_climate_match || _vm.inFlightRequest_future_climate_match) ? true : false),expression:"(inFlightRequest_gdm_prediction || inFlightRequest_current_climate_match || inFlightRequest_future_climate_match) ? true : false"}],attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{staticClass:"stepper-results",staticStyle:{"padding":"8px 40px 8px 23px"},attrs:{"step":"3"}},[_c('h1',{staticClass:"canonicalSpecies"},[_vm._v(_vm._s(_vm.canonicalSpecies)+"\n        "),(_vm.canonicalSpecies)?_c('v-btn',{attrs:{"id":"speciesInfo","color":"info","icon":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.speciesInfoModal = true; _vm.speciesInfoModalClicked()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("info")])],1):_vm._e()],1),_vm._v(" "),(!_vm.canonicalSpecies)?_c('h1',{staticClass:"canonicalSpecies"},[_vm._v("No results")]):_vm._e(),_vm._v(" "),_c('p',[(_vm.speciesPlantNETurl || _vm.speciesAPCurl)?_c('span',[_vm._v("View at ")]):_vm._e(),(_vm.speciesPlantNETurl)?_c('a',{attrs:{"target":"_blank","href":_vm.speciesPlantNETurl}},[_vm._v("PlantNET")]):_vm._e(),(_vm.speciesPlantNETurl && _vm.speciesAPCurl)?_c('span',[_vm._v(" or ")]):_vm._e(),(_vm.speciesAPCurl)?_c('a',{attrs:{"target":"_blank","href":_vm.speciesAPCurl}},[_vm._v("Atlas of Living Australia")]):_vm._e()]),_vm._v(" "),(_vm.canonicalSpecies)?_c('v-list',{staticClass:"results-list",attrs:{"dense":""}},[(_vm.specialZoneSpecies)?_c('v-list-tile',[_c('v-list-tile-avatar',{attrs:{"size":"25"}},[_c('v-icon',{attrs:{"color":"specialZones","x-large":""}},[_vm._v("stop")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticStyle:{"font-size":"20px"}},[_vm._v("Special conditions apply")])],1)],1):_vm._e(),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',{attrs:{"size":"25"}},[_c('v-icon',{attrs:{"color":"herbarium_records","small":""}},[_vm._v("lens")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('v-checkbox',{attrs:{"label":"Herbarium records","disabled":_vm.herbarium_records_state == 'initial',"loading":_vm.inFlightRequest_herbarium_records ? true : false},model:{value:(_vm.herbarium_records_toggle),callback:function ($$v) {_vm.herbarium_records_toggle=$$v},expression:"herbarium_records_toggle"}})],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticStyle:{"padding-left":"31px"}},[_c('em',[_vm._v("(Sourced from ALA)")])])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',{attrs:{"size":"25"}},[_c('v-icon',{attrs:{"color":"recommended_collection_area","medium":""}},[_vm._v("cloud_circle")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('v-checkbox',{attrs:{"label":"Recommended collection area","disabled":_vm.recommended_collection_area_state == 'initial',"loading":_vm.inFlightRequest_gdm_prediction ? true : false},model:{value:(_vm.recommended_collection_area_toggle),callback:function ($$v) {_vm.recommended_collection_area_toggle=$$v},expression:"recommended_collection_area_toggle"}})],1)],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',{attrs:{"size":"25"}},[_c('v-icon',{attrs:{"color":"similar_environments_current","x-large":""}},[_vm._v("stop")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('v-checkbox',{attrs:{"label":"Similar environments (Current)","disabled":_vm.similar_environments_current_state == 'initial',"loading":_vm.inFlightRequest_current_climate_match ? true : false},model:{value:(_vm.similar_environments_current_toggle),callback:function ($$v) {_vm.similar_environments_current_toggle=$$v},expression:"similar_environments_current_toggle"}})],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticStyle:{"padding-left":"31px"}},[_c('em',[_vm._v("(Matches current site conditions)")])])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',{attrs:{"size":"25"}},[_c('v-icon',{attrs:{"color":"similar_environments_future","x-large":""}},[_vm._v("stop")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('v-checkbox',{attrs:{"label":"Similar environments (2050)","disabled":_vm.similar_environments_future_state == 'initial',"loading":_vm.inFlightRequest_future_climate_match ? true : false},model:{value:(_vm.similar_environments_future_toggle),callback:function ($$v) {_vm.similar_environments_future_toggle=$$v},expression:"similar_environments_future_toggle"}})],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticStyle:{"padding-left":"31px"}},[_c('em',[_vm._v("(Matches future conditions at site in 2050)")])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-alert',{attrs:{"outline":"","type":"error","value":_vm.resultsError}},[_vm._v("\n          "+_vm._s(_vm.resultsErrorMessage)+"\n        ")]),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","open-delay":"0"}},[(_vm.canonicalSpecies)?_c('v-btn',{attrs:{"slot":"activator","id":"downloadResults","color":"primary","disabled":(_vm.inFlightRequest_gdm_prediction || _vm.inFlightRequest_current_climate_match || _vm.inFlightRequest_future_climate_match || _vm.inFlightRequest_downloadResults) ? true : false,"loading":!!_vm.inFlightRequest_downloadResults,"block":""},on:{"click":function($event){$event.stopPropagation();_vm.downloadResults()}},slot:"activator"},[_vm._v("\n            Download Results\n            "),_c('span',{attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{staticClass:"loading-spin",attrs:{"dark":""}},[_vm._v("cached")]),_vm._v("Downloading results...")],1)]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("as a PDF for viewing and printing")])],1),_vm._v(" "),(!!_vm.inFlightRequest_downloadResults)?_c('v-progress-linear',{attrs:{"color":"info","height":"10","value":_vm.downloadResultsProgress}}):_vm._e()],1)],1),_vm._v(" "),(_vm.canonicalSpecies || _vm.lng || _vm.lat)?_c('v-layout',{attrs:{"mt-4":""}},[_c('v-btn',{staticClass:"mx-auto",attrs:{"color":"secondary","small":""},on:{"click":_vm.reset}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("clear")]),_vm._v("\n        Reset\n      ")],1)],1):_vm._e()],1),_vm._v(" "),_c('v-content',[_c('v-container',{staticClass:"map-container",attrs:{"fluid":"","fill-height":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('div',{attrs:{"id":"map"}})])],1)],1),_vm._v(" "),_c('v-btn-toggle',{staticClass:"map-background",attrs:{"mandatory":""},model:{value:(_vm.map_background),callback:function ($$v) {_vm.map_background=$$v},expression:"map_background"}},[_c('v-btn',{attrs:{"flat":"","value":"streets-v10"}},[_vm._v("\n        Map\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","value":"satellite-streets-v10"}},[_vm._v("\n        Satellite\n      ")])],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"id":"drawerCollapseButton","color":"primary","absolute":"","top":"","left":"","fab":"","small":"","data-expanded":!_vm.collapsed},on:{"click":function($event){_vm.collapsed = !_vm.collapsed},"transitionend":_vm.drawerCollapseToggled}},[(_vm.collapsed)?_c('v-icon',[_vm._v("arrow_forward")]):_c('v-icon',[_vm._v("arrow_back")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("F53E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// CONCATENATED MODULE: ./src/main.js


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















vue_esm["default"].use(vuetify_default.a, {
  theme: Theme
});

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: {
    id: 'G-QB79RSC2K1'
  }
});

vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Y22I":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DART_logo.e1b4ee9.jpg";

/***/ }),

/***/ "c+ko":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sqv7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/splash.4b5559b.png";

/***/ }),

/***/ "tLfa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uTBe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xFFW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/HSBC-small-logo-no-tagline_C.a5ccec4.jpg";

/***/ }),

/***/ "xnE8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b92a9d30b9878224c255.js